import React, { useEffect } from 'react';

// Components
import { useParams } from 'react-router-dom';
import { Dispatch } from '../../store/store';
import { connect } from 'react-redux';
import { CycleChartWrapper } from '../../components/CycleChart';

type ComponentProps = ReturnType<typeof mapDispatch>;

const CycleView: React.FC<ComponentProps> = ({
  getLocation,
  getContract,
  getScreen,
}) => {
  const { clientId, contractId, screenId } = useParams();

  const fetchData = async () => {
    await getLocation(clientId);
    await getContract(contractId);
    
    if (screenId) {
      await getScreen({ screenId });
    }
  };

  useEffect(() => {
    fetchData()
  }, []);

  return (
    <div className="p-cycle w-full h-full">
      <CycleChartWrapper />
    </div>
  );
};

const mapDispatch = (dispatch: Dispatch) => ({
  getLocation: dispatch.locations.getLocation,
  getContract: dispatch.contracts.getContract,
  getScreen: dispatch.screens.getOneById,
});

export default connect(null, mapDispatch)(CycleView);
